module.exports = __webpack_public_path__ + "img/sx.1c9f12c5.svg";